module.exports = __webpack_public_path__ + "img/pmx.18bead5f.jpg";